(function () {
    'use strict';

    angular
        .module('app')
        .controller('SystemSetting', SystemSetting);

    SystemSetting.$inject = [
        'SystemService',
        'DialogService',
        'ChilliUserProfileService',
        '$q',
        'WindowTitleService'];

    function SystemSetting(
        SystemService,
        DialogService,
        ChilliUserProfileService,
        $q,
        WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.getLink = getLink;
        vm.entityTypeLinks = {};
        vm.settingList = [];

        activate();

        function activate() {
            WindowTitleService.setTitle('Settings');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                return SystemService.getSystemMenuOptions()
                    .then(loadMenuOptionsOk, loadMenuOptionsError);

                function loadMenuOptionsOk(menuOptions) {
                    vm.settingList = menuOptions;

                    return getEntityType('Organisation');
                }

                function loadMenuOptionsError(response) {
                    return DialogService.error('Error loading menu options', response);
                }
            }
        }

        function getLink(item) {
            var result = '';

            switch (item.Name) {
                case 'Blocked Email Addresses':
                    result = '#/system/emailaddress';
                    break;
                case 'Communication Settings':
                    result = '#/system/setting/communication';
                    break;
                case 'Dashboard Panels':
                    result = '#/dashboard/setting';
                    break;
                case 'Document Templates':
                    result = '#/documenttemplates';
                    break;
                case 'Email Templates':
                    result = '#/emailtemplates';
                    break;
                case 'Entity Templates':
                    result = '#/entitytemplates';
                    break;
                case 'Organisation Settings':
                    result = vm.entityTypeLinks.Organisation;
                    break;
                case 'Other':
                    result = '#/system/setting/other';
                    break;
                case 'SMS Templates':
                    result = '#/smstemplates';
                    break;
                case 'Tags':
                    result = '#/system/tags';
                    break;
                case 'Users':
                    result = '#/system/user';
                    break;
                case 'Workflows':
                    result = '#/workflow';
                    break;
                case 'Recycle Bin':
                    result = '#/system/deleteditem';
                    break;
                case 'Xero Integration':
                    result = '#/system/xerointegration';
                    break;
            }

            return result;
        }

        function getEntityType(entityType) {
            return SystemService.getEntityTypeLink(entityType)
                .then(getEntityTypeLinkOk, getEntityTypeLinkError);

            function getEntityTypeLinkOk(data) {
                vm.entityTypeLinks[entityType] = '#' + data;
            }

            function getEntityTypeLinkError(response) {
                var setting = null;

                switch (entityType) {
                    case 'Organisation':
                        setting = _.find(vm.settingList, function (setting) {
                            return setting.Name === 'Organisation Settings';
                        });
                        break;
                }

                if (!_.isNil(setting)) {
                    setting.Error = 'Error retrieving setting link.';
                }
            }
        }
    }
})();
